import { createObjectValidator, validateNumber } from "../../../packages/validator/validator.js";
import { CloudEntryType, validateCloudEntryType } from "./CloudEntryType.js";
import { validatePath } from "./validatePath.js";

/**
 * One path or directory entry under the Cloud interface.
 */
export type CloudEntry = {
  /**
   * Name of the file or directory. Not a full or relative path.
   */
  name: string;
  size: number;
  type: CloudEntryType;
};

export const validateCloudEntry = createObjectValidator<CloudEntry>("CloudEntry", {
  name: validatePath,
  type: validateCloudEntryType,
  size: validateNumber
});
